import { motion } from 'motion/react';
import { useEffect, useState } from 'react';

// ─── Risk Reduction Bar Chart ────────────────────────────────────────────────

const DATA_POINTS = [
  { label: 'Now', value: 100, isBaseline: true },
  { label: '6 mo', value: 88, isBaseline: false },
  { label: '1 yr', value: 74, isBaseline: false },
  { label: '2 yr', value: 62, isBaseline: false },
  { label: '5 yr', value: 48, isBaseline: false },
] as const;

const MAX_BAR_HEIGHT = 120;

function RiskReductionGraph() {
  const [animated, setAnimated] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setAnimated(true), 300);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="mx-auto mt-6 max-w-sm">
      <div className="flex items-end justify-between gap-3" style={{ height: MAX_BAR_HEIGHT + 40 }}>
        {DATA_POINTS.map((point, i) => {
          const barHeight = (point.value / 100) * MAX_BAR_HEIGHT;
          return (
            <div key={point.label} className="flex flex-1 flex-col items-center gap-2">
              <div
                className="w-full rounded-lg transition-all duration-700 ease-out"
                style={{
                  height: animated ? barHeight : 0,
                  backgroundColor: point.isBaseline ? 'rgba(255,255,255,0.15)' : '#7CF1C7',
                  opacity: point.isBaseline ? 0.5 : 0.4 + i * 0.15,
                  transitionDelay: `${i * 150}ms`,
                }}
              />
              <span className="text-xs font-medium text-white/55">{point.label}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ─── Component ──────────────────────────────────────────────────────────────

export function RiskReductionInterstitial() {
  return (
    <div className="flex h-full w-full flex-col items-center justify-center px-6">
      <motion.div
        className="w-full max-w-lg space-y-6 text-center"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
        style={{ willChange: 'transform, opacity' }}
      >
        <h2 className="text-2xl font-semibold leading-tight text-white md:text-3xl">
          Many meaningful cancer risk drivers are modifiable.
        </h2>
        <p className="mx-auto max-w-md text-lg leading-relaxed text-white/65">
          We'll show you what's within your control, and how to act on it to reduce your risk.
        </p>
        <RiskReductionGraph />
      </motion.div>
    </div>
  );
}
